<div class="wrapper-body">
  <div class="ppl-tabs">

    <div class="ppl-nav ppl-nav-tabs">
      <div *ngFor="let menuItem of horizontalMenuItemstoDisplay;" class="ppl-nav-item">
        <a class="ppl-nav-link" [ngClass]="{'single-tab': horizontalMenuItemstoDisplay.length === 1}"
          [class.active]="menuItem.menu_id.toLocaleLowerCase() === selectedMenuItem" (click)="onMenuSelection(menuItem)"
          href="javascript:void(0)">
          {{ menuItem.menu_label }}
        </a>
      </div>
    </div>

    <!-- Tab Content -->
    <div class="tab-content" [ngSwitch]="selectedMenuItem?.toLowerCase()">
      <ppl-lead-detail-summary *ngSwitchCase="'summary'" [readOnly]="true"></ppl-lead-detail-summary>
      <ppl-lead-information *ngSwitchCase="'enrollmentinformation'" [readOnly]="true"></ppl-lead-information>
      <ppl-authorization *ngSwitchCase="'authorizations'" [readOnly]="true"></ppl-authorization>
      <ppl-associations *ngSwitchCase="'associations'" [readonly]="true"></ppl-associations>
      <ppl-form-checklist *ngSwitchCase="'forms'" [readonly]="true"></ppl-form-checklist>
      <ppl-additional-attributes *ngSwitchCase="'additionalattributes'" [readonly]="true"></ppl-additional-attributes>
    </div>
  </div>
</div>